<template>
  <div class="container">
    <div class="row mx-auto">
      <h2 class="col">
        Admin
      </h2>
      <div class="col my-auto text-right" v-if="user">
        <span class="my-auto mr-2">{{user.displayName}}</span>
        <button class="btn btn-outline-danger" @click="logOut">Cerrar sesión</button>
      </div>
    </div>
    <template v-if="user">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center">
                Nombre
              </th>
              <th class="text-center">
                Precios
              </th>
              <th class="text-center">
                Editar
              </th>
              <th class="text-center">
                Eliminar
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="99" veralign="center" class="text-center p-0">
                <div class=" d-grid gap-2 w-100">
                  <button class="btn btn-outline-success rounded-0 fw-bold" @click="openEdit()"><i class="fas fa-plus"></i> Nuevo</button>
                </div>
              </td>
            </tr>
            <template v-if="catalog && catalog.length > 0">
              <TableProduct @del="del" @edit="openEdit" @showAlert="showAlert" :product="product" v-for="(product, index) of catalog" :key="index" />
            </template>
          </tbody>
        </table>
      </div>
      <transition name="fade">
        <div class="modal-backdrop" style="opacity: 0.5" v-show="edit"></div>
      </transition>
      <transition name="fade"> 
        <div class="modal fade show" id="staticBackdrop" style="display: block" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="title" aria-modal="true" v-show="edit">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl h-100">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="title">Producto</h5>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" @click="cancelEdit"></button>
              </div>
              <div class="modal-body">
                <div class="row mx-auto">
                  <div class="col-12 mb-2">
                    <label for="name">Nombre</label>
                    <input class="form-control" type="text" placeholder="Nombre" id="name" v-model="edit.name">
                  </div>
                  <div class="col accordion mb-5" id="accordionForm">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-toggle="collapse" data-target="#categories" aria-expanded="true" aria-controls="collapseOne">
                          Categorias
                        </button>
                      </h2>
                      <div id="categories" class="accordion-collapse collapse" aria-labelledby="headingOne" data-parent="#accordionForm">
                        <div class="accordion-body">
                          <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Categoria" v-model="category">
                            <button class="btn btn-outline-secondary" type="button" @click="addCategory">Agregar</button>
                          </div>
                          <div>
                            <span class="badge bg-primary mr-2 text-capitalize" v-for="(cat, index) of edit.categories" :key="index">
                              <router-link class="text-light mr-2" target="_blank" :to="{name: 'Catalog', query:{category: cat}}" >
                                {{cat}}
                              </router-link>
                              <button class="btn text-light p-0" @click="removeFrom(edit.categories, index)">
                                <i class="fas fa-times"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accodion-item">
                      <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-toggle="collapse" data-target="#prices" aria-expanded="true" aria-controls="collapseOne">
                          Precios
                        </button>
                      </h2>
                      <div id="prices" class="accordion-collapse collapse" aria-labelledby="headingOne" data-parent="#accordionForm">
                        <div class="accordion-body">
                          <div class="input-group mb-3">
                            <input type="number" class="form-control" min="0" placeholder="Cantidad" v-model="price.quantity">
                            <input type="number" class="form-control" min="0" placeholder="Precio" v-model="price.price">
                            <button class="btn btn-outline-secondary" type="button" @click="addPrice">Agregar</button>
                          </div>
                          <div>
                            <span class="badge bg-primary mr-2 text-capitalize" v-for="(price, index) of edit.prices" :key="index">
                              {{price.quantity}} por ${{price.price}}
                              <button class="btn text-light p-0" @click="removeFrom(edit.prices, index)">
                                <i class="fas fa-times"></i>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accodion-item border-bottom rounded">
                      <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-toggle="collapse" data-target="#images" aria-expanded="true" aria-controls="collapseOne">
                          Imagenes
                        </button>
                      </h2>
                      <div id="images" class="accordion-collapse collapse" aria-labelledby="headingOne" data-parent="#accordionForm">
                        <div class="accordion-body">
                          <div class="input-group mb-3">
                            <input type="url" class="form-control" placeholder="URL" v-model="img">
                            <button class="btn btn-outline-secondary" type="button" @click="addImg">Agregar</button>
                          </div>
                          <div class="row mx-auto">
                            <div class="col-lg-6 col-12 border row mx-auto p-1 mx-1" v-for="(img, index) of edit.img" :key="index">
                              <div class="col text-center m-auto">
                                <img :src="img" class="img-fluid" style="max-height:50px;">
                              </div>
                              <div class="col text-center m-auto">
                                <button class="btn btn-outline-warning" @click="edit.defaultImg = index">
                                  <i class="fa-star" :class="{fas: index==edit.defaultImg, far: index!=edit.defaultImg}"></i>
                                </button>
                              </div>
                              <div class="col text-center m-auto">
                                <button class="btn btn-outline-danger" @click="removeImg(index)">
                                  <i class="fas fa-times"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="save" :disabled="invalid()">Guardar</button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </template>
    <template v-else>
      <div class="text-center">
        <button class="btn btn-outline-dark mb-3" @click="logIn">Iniciar sesión</button>
        <p class="text-dark">Si no es un usuario administrador, no inicie sesión</p>
      </div>
    </template>
  </div>
</template>

<script>
import TableProduct from '../components/TableProduct';
import { fb } from '../firebase';
import firebase from 'firebase';

export default {
  name: 'Admin',
  components: { TableProduct },
  data(){
    const catalog = fb.getDocsFromCollectionRealtime('catalog');
    var user = null;
    return{
      catalog,
      edit: '',
      category: '',
      price:{
        quantity: 0,
        price:0
      },
      img: '',
      beforeEdit: null,
      user
    }
  },
  mounted(){
    const users = [
      "kSXk6EeLopXYFvyh4BAoUuuAId52", // Matias
      "qlJSiQdfGef7AQRKWVG7Mn2bN0q1" // Sofia
    ];
    firebase.auth().onAuthStateChanged((u) => {
        if (u && users.includes(u.uid)) this.user = u
        else{
          firebase.auth().signOut()
          this.user = null
        }
    })
  },
  methods:{
    showAlert(type, message){
      this.$emit("showAlert", type, message)
    },
    save(){
      if(confirm("Esta seguro de que desea guardar el producto?")){
        document.querySelector('body').classList.remove('overflow-hidden');
        fb.createAndUpdateDoc('catalog', this.edit).then(() => {
          this.$emit('showAlert', 'success', `Producto ${this.edit.id ? 'modificado' : 'creado'} con exito`)
        })
        if(this.edit.id){
          let index = this.catalog.findIndex(p => p.id == this.edit.id);
          this.catalog[index] = this.edit;
        }else{
          this.catalog.push(JSON.parse(JSON.stringify(this.edit)))
          this.catalog.sort((a,b) => a.name - b.name)
        }
        this.edit = '';
        // this.catalog = fb.getDocsFromCollectionRealtime('catalog');
      }
    },
    openEdit(data = {name: '', categories: [], prices: [], img: [], defaultImg: 0}){
      console.log(data)
      document.querySelector('body').classList.add('overflow-hidden')
      this.edit =  JSON.parse(JSON.stringify(data)); // para eliminar la reactividad
    },
    cancelEdit(){
      if(confirm("Esta seguro de que desea salir sin guardar?")){
        this.edit = ''
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    },
    addTo(to, data){
      if(!to.includes(data)) to.push(data)
    },
    addPrice(){
      if(!this.edit.prices.find(p => p.quantity == this.price.quantity && p.price == this.price.price)){
        this.edit.prices.push({...this.price})
      }
      this.price = {
        price: 0,
        quantity: 0
      }
    },
    addImg(){
      this.addTo(this.edit.img, this.img.trim())
      this.img = ''
    },
    addCategory(){
      this.addTo(this.edit.categories, this.category.trim().toLowerCase())
      this.category = ''
    },
    removeFrom(from, index){
      from.splice(index,1);
    },
    removeImg(index){
      this.removeFrom(this.edit.img, index);
      if(this.edit.defaultImg >= this.edit.img.length) this.edit.defaultImg = 0
    },
    invalid(){
      return !this.edit || (!this.edit.name || this.edit.img.length == 0 || this.edit.prices.length == 0 || this.edit.categories.length == 0 || this.defaultImg)
    },
    logIn(){
      fb.logIn()
    },
    logOut(){
      fb.logOut()
    },
    del(id){
      let index = this.catalog.findIndex(p => p.id == id);
      this.catalog.splice(index, 1);
      this.$emit('showAlert', 'success', 'Producto eliminado con exito')
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion-button{
  &::after{
    color: black;
    filter: grayscale(1) brightness(0);
  }
  &:focus, &:not(.collapsed){
    background: rgba(0,0,0,0.1);
    color: black;
  }
}
</style>